import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Actor = {
  type: 'SUPER_ADMIN' | 'OWNER' | 'AGENT' | 'END_CUSTOMER';
  id: string;
  role: string;
  tenantId?: string;
  name: string;
  email?: string;
};

type Tenant = { id: string; slug: string; name: string };

type AuthState = {
  actor: Actor | null;
  tenant: Tenant | null;
  accessToken: string | null;
  refreshToken: string | null;
  setSession: (s: { actor: Actor; tenant?: Tenant; accessToken: string; refreshToken: string }) => void;
  clear: () => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      actor: null,
      tenant: null,
      accessToken: null,
      refreshToken: null,
      setSession: ({ actor, tenant, accessToken, refreshToken }) =>
        set({ actor, tenant: tenant ?? null, accessToken, refreshToken }),
      clear: () => set({ actor: null, tenant: null, accessToken: null, refreshToken: null }),
    }),
    { name: 'ttb-auth' },
  ),
);
